export const ADD_CONTACT: string = "ADD_CONTACT";
export const CLEAR_CONTACTS: string = "CLEAR_CONTACTS";

export function addContact(kid:string,contact: string, name:string,place:string, created:string,email:string): IAddContactActionType {
    return { type: ADD_CONTACT, kid:kid, contact:contact, name:name, place:place, created:created,email:email}
}
export function clearContacts(): IClearContactActionType {
    return { type: CLEAR_CONTACTS};
}


interface IAddContactActionType { 
    type:string,
    kid:string,
    contact: string, 
    name:string,
    place:string, 
    created:string,
    email:string
}

interface IClearContactActionType { 
    type:string 
}